import PropTypes from "prop-types";
import Loader from "shared/components/Loader";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "../utils/constants";

const InsurancePlans = ({ View, filter, ...props }) => {
  const variables = {
    ...filter,
    skip: parseInt(filter.skip) ?? INITIAL_VALUES.skip,
    take: parseInt(filter.take) ?? INITIAL_VALUES.take,
  };
  const query = useQuery(graphql.queries.INSURANCE_PLANS, {
    variables,
  });
  const WrappedView = Loader(View);
  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        type: "insurancePlans",
      }}
    />
  );
};

InsurancePlans.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

InsurancePlans.defaultProps = {
  filter: {},
};

export default InsurancePlans;
